// SPDX-License-Identifier: AGPL-3.0-or-later

import {z} from 'zod';

/** A server-generated mail alert, independent of the mailbox's display refresh. */
export const MailNotificationSchema = z.object({
	notification_id: z.uuid(),
	title: z.string(),
	body: z.string(),
	tag: z.string(),
	mail_message_id: z.string().min(1).optional(),
});

export type MailNotification = z.infer<typeof MailNotificationSchema>;
